import {
  Alert,
  Button,
  Card,
  CardContent,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Snackbar,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { AiFillDelete, AiOutlinePlus } from "react-icons/ai";
import Skeleton from "react-loading-skeleton";
import Toast from "../../components/Toast.jsx";
import Constants from "../../data/Constants.js";
import Utils from "../../utils/index.js";
import { useNavigate, useOutletContext } from "react-router-dom";
import {
  createSingleCoupon,
  deleteSingleCoupon,
  getCouponsList,
  updateSingleCoupon,
} from "../../services/coupon.service";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import Coupon from "../../components/Coupon.jsx";
import { getCoursesList } from "../../services/course.service.js";
import { BsCheck } from "react-icons/bs";
import { useConfirm } from "material-ui-confirm";

function Coupons(props) {
  const { setProgress, setToast, isRefreshed, isLoading } = useOutletContext();
  const confirm = useConfirm();
  const navigate = useNavigate();
  const [coupons, setCoupons] = useState(false);
  const [courses, setCourses] = useState(false);
  const [render, setRender] = useState();
  const [selectedCoupon, selectCoupon] = useState();

  const forceRender = () => {
    setRender(Math.random()); // todo improve this
  };

  useEffect(() => {
    async function api() {
      try {
        setProgress(true);
        const data = await getCouponsList();
        setProgress(false);
        if (data) {
          setCoupons(data);
        } else {
          // error
          setToast({ error: true, message: Constants.Error.UNKNOWN });
        }
      } catch (error) {
        // error
        setProgress(false);
        setToast({ error: true, message: Utils.CustomErrorMessage(error) });
      }
    }
    async function coursesApi() {
      try {
        const data = await getCoursesList();
        if (data) {
          setCourses(data);
        }
      } catch (error) {
        // error
        setToast({ error: true, message: Utils.CustomErrorMessage(error) });
      }
    }
    api();

    coursesApi();
  }, [render, isRefreshed]);

  const formSubmitHandler = async () => {
    // client validations
    if (!selectedCoupon.code) {
      return setToast({
        error: true,
        message: "Coupon Code is required",
        autohide: 5000,
      });
    }

    if (
      selectedCoupon.fixedDiscount == null &&
      selectedCoupon.percentageDiscount == null
    ) {
      return setToast({
        error: true,
        message: "Discount is required",
        autohide: 5000,
      });
    }

    const coupon = { ...selectedCoupon };

    if (coupon.discountType == "FIXED") {
      coupon.percentageDiscount = null;
    } else {
      coupon.fixedDiscount = null;
    }

    try {
      setProgress(true);

      const res = coupon._new
        ? await createSingleCoupon(coupon)
        : await updateSingleCoupon(coupon._id, coupon);

      setProgress(false);
      selectCoupon(null);
      forceRender();
      setToast({
        success: true,
        message: coupon._new
          ? Constants.Actions.Created.Success("Coupon")
          : Constants.Actions.Updated.Success("Coupon"),
      });
    } catch (error) {
      setProgress(false);
      setToast({ error: true, message: Utils.CustomErrorMessage(error) });
    }
  };

  const inputChangeHandler = (e) => {
    selectCoupon({ ...selectedCoupon, [e.target.name]: e.target.value });
  };

  return (
    <Grid container className="justify-center md:justify-start">
      {!coupons && isLoading && (
        <React.Fragment>
          <Skeleton
            className="m-2"
            style={{ width: "300px", height: "300px" }}
          />
          <Skeleton
            className="m-2"
            style={{ width: "300px", height: "300px" }}
          />
          <Skeleton
            className="m-2"
            style={{ width: "300px", height: "300px" }}
          />
        </React.Fragment>
      )}

      {coupons &&
        coupons.map((coupon, index) => {
          return (
            <Coupon
              coupon={coupon}
              onDelete={(e) => {
                e.preventDefault();
                confirm({
                  title: "Delete Coupon",
                  description: "Are you sure you want to delete this Coupon?",
                })
                  .then(async () => {
                    if (!coupon._new) {
                      await deleteSingleCoupon(coupon._id);
                    } else {
                      const data = [...coupons];
                      data.splice(index, 1);
                      setCoupons(data);
                    }
                    forceRender();
                  })
                  .catch(() => {});
              }}
              onClick={() => {
                selectCoupon(coupon);
              }}
            />
          );
        })}

      <div
        className="p-5 bg-blue-100 m-2 border-4 border-dotted border-primary cursor-pointer flex items-center w-full md:w-auto"
        onClick={() => {
          const data = [...coupons];
          const index = data.findIndex((val) => val._new == true);
          const newCoupon = {
            _new: true,
            code: "",
            courses: [],
            applicableOn: [],
            percentageDiscount: 0,
            fixedDiscount: null,
            expiredAt: null,
            minAmount: "",
            maxAmount: "",
            discountType: "PERCENTAGE",
          };

          if (index == -1) {
            data.push(newCoupon);
            setCoupons(data);
            selectCoupon(newCoupon);
          } else {
            // select already created new coupon
            selectCoupon(data[index]);
          }
        }}
      >
        <div className="text-primary m-auto font-bold">
          <AiOutlinePlus size={100} />
        </div>
      </div>

      <div className="m-2  border-primary w-full">
        {selectedCoupon && (
          <div className="flex gap-3 flex-col p-2">
            <h1 className="font-extrabold m-2 text-lg">Edit Coupon</h1>

            <div className="grid grid-cols-2">
              <div>
                <RadioGroup
                  row
                  value={selectedCoupon.discountType}
                  onChange={(e) => {
                    const temp = {
                      ...selectedCoupon,
                      discountType: e.target.value,
                    };

                    selectCoupon(temp);
                  }}
                >
                  <FormControlLabel
                    value="FIXED"
                    control={<Radio />}
                    label="Fixed"
                  />
                  <FormControlLabel
                    value="PERCENTAGE"
                    control={<Radio />}
                    label="Percentage"
                  />
                </RadioGroup>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-3">
              <div className="">
                <FormControl fullWidth>
                  <InputLabel>Applicable On</InputLabel>

                  <Select
                    label="Applicable On"
                    value={selectedCoupon.applicableOn ?? []}
                    fullWidth
                    multiple
                    onChange={(e) => {
                      console.log(e.target.value);
                      selectCoupon({
                        ...selectedCoupon,
                        applicableOn: e.target.value,
                      });
                    }}
                  >
                    <MenuItem value="COURSE">COURSE</MenuItem>
                    <MenuItem value="COUNSELLING">COUNSELLING</MenuItem>
                  </Select>
                </FormControl>
              </div>

              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DateTimePicker
                  label="Expiry Date"
                  value={selectedCoupon.expiredAt}
                  fullWidth
                  onChange={(time) => {
                    selectCoupon({
                      ...selectedCoupon,
                      expiredAt: time.format(),
                    });
                  }}
                  renderInput={(params) => (
                    <TextField value={"sds"} {...params} fullWidth />
                  )}
                />
              </LocalizationProvider>
            </div>

            <div className="flex gap-3 ">
              <TextField
                label="Coupon Code"
                variant="filled"
                size="small"
                name="code"
                className="col-span-2"
                value={selectedCoupon.code}
                onChange={inputChangeHandler}
                fullWidth
              />

              {selectedCoupon &&
                selectedCoupon.discountType == "PERCENTAGE" && (
                  <TextField
                    label="Percentage Discount"
                    variant="filled"
                    onChange={inputChangeHandler}
                    type="number"
                    size="small"
                    value={selectedCoupon.percentageDiscount}
                    name="percentageDiscount"
                    fullWidth
                  />
                )}

              {selectedCoupon && selectedCoupon.discountType == "FIXED" && (
                <TextField
                  label="Fixed Discount"
                  variant="filled"
                  onChange={inputChangeHandler}
                  type="number"
                  size="small"
                  name="fixedDiscount"
                  value={selectedCoupon.fixedDiscount}
                  fullWidth
                />
              )}
            </div>

            <div className="flex gap-3 ">
              <TextField
                label="Min Product Amount for Discount"
                variant="filled"
                type="number"
                value={selectedCoupon.minAmount}
                size="small"
                onChange={inputChangeHandler}
                name="minAmount"
                className="col-span-2"
                fullWidth
              />

              <TextField
                label="Max Product Amount for Discount"
                variant="filled"
                type="number"
                onChange={inputChangeHandler}
                size="small"
                value={selectedCoupon.maxAmount}
                name="maxAmount"
                className="col-span-2"
                fullWidth
              />
            </div>

            {selectedCoupon.applicableOn.includes("COURSE") && (
              <>
                {" "}
                <div className="grid grid-cols-2 gap-3 ">
                  <div className="">
                    <TextField
                      label="Add Course to Coupon"
                      variant="filled"
                      size="small"
                      name="type"
                      className="col-span-2"
                      value={"ALL"}
                      onChange={(e) => {
                        if (e.target.value) {
                          const t = [...selectedCoupon.courses];

                          if (!t.includes(e.target.value)) {
                            t.push(e.target.value);
                            selectCoupon({ ...selectedCoupon, courses: t });
                          }
                        }
                      }}
                      select
                      fullWidth
                    >
                      <MenuItem key={-1} value="">
                        ALL
                      </MenuItem>
                      {courses.map((course, index) => {
                        return (
                          <MenuItem key={index} value={course._id}>
                            {course.name}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                  </div>
                </div>
                <div className="">
                  <h1 className="my-4 font-bold">Eligible Courses</h1>

                  {selectedCoupon.courses.length == 0 && (
                    <div className="text-green-500 flex gap-2 items-center">
                      <BsCheck size={30} /> Applicable on all courses
                    </div>
                  )}

                  {selectedCoupon.courses.map((courseId, index) => {
                    const course = courses.find((e, i) => {
                      return e._id == courseId;
                    });

                    if (course) {
                      return (
                        <div className="p-2 bg-secondary rounded-sm flex items-center m-2">
                          <div className="flex-grow">
                            {course.name + " (" + course._id + ")"}
                          </div>
                          <div>
                            <IconButton
                              onClick={() => {
                                const t = [...selectedCoupon.courses];
                                t.splice(index, 1);
                                selectCoupon({ ...selectedCoupon, courses: t });
                              }}
                            >
                              <AiFillDelete />
                            </IconButton>
                          </div>
                        </div>
                      );
                    }
                  })}
                </div>
              </>
            )}

            <div className="my-4 text-right">
              <Button variant="contained" onClick={formSubmitHandler}>
                {selectedCoupon._new ? "Create" : "Update"} Coupon
              </Button>
            </div>
          </div>
        )}
      </div>
    </Grid>
  );
}

export default Coupons;
